import { EFavoritesActionTypes, IUpdateUserFavoritesPayload } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const updateUserFavorites = actionGenerator<
  EFavoritesActionTypes.UpdateUserFavorites,
  IUpdateUserFavoritesPayload
>(EFavoritesActionTypes.UpdateUserFavorites);
